import React from 'react';
import PropTypes from 'prop-types';
export var Closure = function Closure(props) {
  React.useEffect(function () {
    return props.onClose;
  }, []);
  return props.children;
};
Closure.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};